export function pdfStylesSet(isSidebarCollapsed: boolean, fullScreenSetted: boolean, isAcept: boolean, isModalViwer: boolean, isNotebookWIdth: boolean): { width: string, height: string } {
    if (isAcept)
        return { width: "100%", height: "100%" }

    if (isNotebookWIdth) {
        if (isModalViwer) 
            return { width: "100%", height: "100%" }
    
        if (isSidebarCollapsed && fullScreenSetted)
            return { width: "94.5%", height: "calc(100% - 217px)" }
    
        if (!isSidebarCollapsed && fullScreenSetted)
            return { width: "73%", height: "calc(100% - 217px)" }
    
        if (isSidebarCollapsed && !fullScreenSetted)
            return { width: "86%", height: "calc(100% - 365px)" }
    
        return { height: "calc(100% - 365px)", width: "64.8%" }
    }

    if (isModalViwer) 
        return { width: "100%", height: "100%" }

    if (isSidebarCollapsed && fullScreenSetted)
        return { width: "95.5%", height: "calc(100% - 217px)" }

    if (!isSidebarCollapsed && fullScreenSetted)
        return { width: "72%", height: "calc(100% - 217px)" }

    if (isSidebarCollapsed && !fullScreenSetted)
        return { width: "87%", height: "calc(100% - 118px)" }

    return { height: "calc(100% - 118px)", width: "66%" }
}

export function dwgStyleSet(isSidebarCollapsed: boolean, fullScreenSetted: boolean, isAcept: boolean, isModalViwer: boolean): { width: string, height: string } {
    if (isAcept) 
        return { width: "100%", height: "100%" }

    if (isModalViwer) 
        return { width: "100%", height: "100%" }

    if (isSidebarCollapsed && fullScreenSetted)
        return { width: "100%", height: "100%" }

    if (!isSidebarCollapsed && fullScreenSetted)
        return { width: "70.3%", height: "92%" }

    if (isSidebarCollapsed && !fullScreenSetted)
        return { width: "1669px", height: "460px" }

    return { height: "460px", width: "63.8%" }
}




export function noViwerStylesSet(isSidebarCollapsed: boolean, fullScreenSetted: boolean, isAcept: boolean, isModalViwer: boolean, isNotebookWIdth: boolean): { width: string, height: string } {
    if (isAcept)
        return { width: "100%", height: "100%" }

    if (isNotebookWIdth) {
        if (isModalViwer) 
            return { width: "100%", height: "100%" }
    
        if (isSidebarCollapsed && fullScreenSetted)
            return { width: "95.7%", height: "65.9%" }
    
        if (!isSidebarCollapsed && fullScreenSetted)
            return { width: "76%", height: "65.9%" }
    
        if (isSidebarCollapsed && !fullScreenSetted)
            return { width: "89.3%", height: "44%" }
    
        return { height: "45%", width: "69.5%" }
    }

    if (isModalViwer) 
        return { width: "100%", height: "100%" }

    if (isSidebarCollapsed && fullScreenSetted)
        return { width: "95.7%", height: "65.9%" }

    if (!isSidebarCollapsed && fullScreenSetted)
        return { width: "76%", height: "65.9%" }

    if (isSidebarCollapsed && !fullScreenSetted)
        return { width: "89.3%", height: "49.6%" }

    return { height: "49.6%", width: "69.5%" }
}


export function fileStylesSet(isSidebarCollapsed: boolean, fullScreenSetted: boolean, isAcept: boolean, isModalViwer: boolean, isNotebookWIdth: boolean): { width: string, height: string } {
    if (isAcept)
        return { width: "100%", height: "100%" }
    
    if (isNotebookWIdth) {
        if (isModalViwer) 
            return { width: "100%", height: "100%" }
    
        if (isSidebarCollapsed && fullScreenSetted)
            return { width: "94.5%", height: "65.2%" }
    
        if (!isSidebarCollapsed && fullScreenSetted)
            return { width: "73%", height: "65.2%" }
    
        if (isSidebarCollapsed && !fullScreenSetted)
            return { width: "86%", height: "44%" }
    
        return { height: "44%", width: "65%" }
    }

    if (isModalViwer) 
        return { width: "100%", height: "100%" }

    if (isSidebarCollapsed && fullScreenSetted)
        return { width: "94.5%", height: "50%" }

    if (!isSidebarCollapsed && fullScreenSetted)
        return { width: "74%", height: "65.2%" }

    if (isSidebarCollapsed && !fullScreenSetted)
        return { width: "87%", height: "43%" }

    return { height: "47.8%", width: "63.9%" }
}

export const tableWidthHandler = (isSidebarCollapsed: boolean, fullScreenSetted: boolean, isNotebookWidth: boolean) : { width: string, height: string } => {

    if (isNotebookWidth) {
        return { width: "1000px", height: "55%" }
    }

    if (isSidebarCollapsed && fullScreenSetted) {
        return { width: "1400px", height: "-webkit-fill-available" }
    }

    if (isSidebarCollapsed && !fullScreenSetted) {
        return { width: "1400px", height: "50%" }
    }

    if (!isSidebarCollapsed && fullScreenSetted) {
        return { width: "1000px", height: "-webkit-fill-available"}
    }

    return { width: "1000px", height: "50%" }
}